<template>
	<div
		class="rounded-circle"
		:class="additionalClasses"
		:style="styleObj"
	></div>
</template>

<script>
export default {
	name: "RadioCircle",
	props: {
		active: Boolean,
		colorDefault: {
			type: String,
			default: "black",
		},
		colorActive: {
			type: String,
			default: "black",
		},
		size: {
			type: String,
			default: "20px",
		},
		borderSizeDefault: {
			type: String,
			default: "2px solid",
		},
		borderSizeActive: {
			type: String,
			default: "4px solid",
		},
		transition: {
			type: String,
			default: "border 100ms ease-in-out",
		},
		additionalClasses: {
			type: String,
			default: "",
		},
		backgroundDefault: {
			type: String,
			default: "transparent",
		},
		backgroundActive: {
			type: String,
			default: "transparent",
		},
		/* NEW: outer ring (second border) */
		outerBorderSizeDefault: { type: String, default: "0px" },   // thickness of outer ring when inactive
		outerBorderSizeActive:  { type: String, default: "0px" },   // e.g. "2px" or "3px"
		outerColorDefault:      { type: String, default: "" },      // fallback to colorDefault if empty
		outerColorActive:       { type: String, default: "" },      // fallback to colorActive if empty
	},
	computed: {
		styleObj() {
      const isActive = this.active;

      const color = isActive ? this.colorActive : this.colorDefault;           // border uses currentColor
      const border = isActive ? this.borderSizeActive : this.borderSizeDefault;

      const outerSize = isActive ? this.outerBorderSizeActive : this.outerBorderSizeDefault;
      const outerColor =
        (isActive ? this.outerColorActive : this.outerColorDefault) || color;  // default to currentColor

      return {
        height: this.size,
        width: this.size,
        minHeight: this.size,
        minWidth: this.size,
        boxSizing: "border-box",
        border,                                   // e.g. "2px solid" — color comes from `color`
        color,                                    // sets `currentColor` for border (and can be reused)
        background: isActive ? this.backgroundActive : this.backgroundDefault,
        boxShadow: outerSize === "0px" ? "none" : `0 0 0 ${outerSize} ${outerColor}`,
        transition: this.transition,
        display: "inline-block",
      };
		},
	},
};
</script>

<style scoped></style>
